const { h, render, Component } = require('preact');
const ViewVoucherSSA = require('./view_voucher')
const TradeInVoucherSSA = require('./trade_in_voucher')
const PrintGiftCardVoucherSSA = require('./print_gift_card_voucher')
const ReturnItemSSA = require('./return_item')
const InactiveTradeInSSA = require('./inactive_trade_in')

class VoucherLevelSSA extends Component {
  constructor(props) {
    super(props);
    this.setState({isSingleGrouponPresent: this.isSingleGrouponPresent()});
    this.setState({userUUID: this.getUserUUID()});
    this.isGrouponRefunded = this.isGrouponRefunded.bind(this);
    this.isGrouponRedeemed = this.isGrouponRedeemed.bind(this);
  }

  isSingleGrouponPresent(){
    return (this.props.orderDetails.groupons) && (this.props.orderDetails.groupons.length == 1)
  }

  getUserUUID(){
    let userUUID = ""
    let configFromDom = Groupon.Utils.getConfigFromDom();
    if (configFromDom.user){
      try{
        userUUID = JSON.parse(configFromDom.user).id;
      }
      catch(err){
        userUUID = "";
      }
    }
    return userUUID;
  }

  isGrouponRefunded(groupon){
    return (groupon.availability) && (groupon.availability == 'refunded');
  }

  isGrouponRedeemed(groupon){
    return (groupon.isCustomerRedeemed) || (groupon.isMerchantRedeemed);
  }

  getElementsForPopup(){
    return {
      image: this.props.orderDetails.deal.largeImageUrl,
      merchantName: this.props.orderDetails.merchant.name,
      purchaseDate: this.props.orderDetails.purchasedAtshortDatetimeStr,
      dealTitle: this.props.orderDetails.deal.title,
      dealUrl: `/deals/${this.props.orderDetails.deal.id}`
    }
  }



  getSSADetails(SSA, firstSSA){
    let elementsForPopup = this.getElementsForPopup()
    switch(SSA){
      case 'trade_in':
        return(
          <TradeInVoucherSSA firstSSA = {firstSSA} landingView = {this.props.landingView}
            isSingleGrouponPresent = {this.state.isSingleGrouponPresent}
            userUUID = {this.state.userUUID}
            elementsForPopup = {elementsForPopup}
            orderDetails = {this.props.orderDetails}
            isGrouponRefunded={this.isGrouponRefunded.bind(this)}
            isGrouponRedeemed={this.isGrouponRedeemed.bind(this)}
          />
        );
      case 'view_voucher':
        return(
          <ViewVoucherSSA landingView = {this.props.landingView}
            isSingleGrouponPresent = {this.state.isSingleGrouponPresent}
            userUUID = {this.state.userUUID}
            elementsForPopup = {elementsForPopup}
            orderDetails = {this.props.orderDetails}
            isGrouponRefunded={this.isGrouponRefunded.bind(this)}
            isGrouponRedeemed={this.isGrouponRedeemed.bind(this)}
          />
        );
      case 'print_gift_card_voucher':
        return(
          <PrintGiftCardVoucherSSA landingView = {this.props.landingView}
            isSingleGrouponPresent = {this.state.isSingleGrouponPresent}
            userUUID = {this.state.userUUID}
            elementsForPopup = {elementsForPopup}
            orderDetails = {this.props.orderDetails}
            isGrouponRefunded={this.isGrouponRefunded.bind(this)}
            isGrouponRedeemed={this.isGrouponRedeemed.bind(this)}
          />
        );
      case 'return_item':
        return(
          <ReturnItemSSA firstSSA = {firstSSA} landingView = {this.props.landingView}
            isSingleGrouponPresent = {this.state.isSingleGrouponPresent}
            userUUID = {this.state.userUUID}
            elementsForPopup = {elementsForPopup}
            orderDetails = {this.props.orderDetails}
            isGrouponRefunded={this.isGrouponRefunded.bind(this)}
            isGrouponRedeemed={this.isGrouponRedeemed.bind(this)}
          />
      );
      case 'inactive_trade_in':
        return(
          <InactiveTradeInSSA landingView = {this.props.landingView}
            orderDetails = {this.props.orderDetails}
          />
      );
    }
  }

  constructSSAs() {
    let constructedSSAs = [];
    let counterSSA = 0;
    this.props.SSAs.forEach(SSA => {
      let firstSSA = false;
      if (this.props.firstSSA && counterSSA === 0) {
        firstSSA = true;
      }
      constructedSSAs.push(this.getSSADetails(SSA, firstSSA));
      counterSSA++;
    });
    return constructedSSAs;
  }

  isAllGrouponsRefundedOrRedeemed(){
    if (this.props.orderDetails && this.props.orderDetails.groupons){
      for(let i = 0; i < this.props.orderDetails.groupons.length; ++i){
        let groupon = this.props.orderDetails.groupons[i];
        if(groupon.availability && groupon.availability != 'refunded' && !(groupon.isCustomerRedeemed || groupon.isMerchantRedeemed)){
          return false;
        }
      }
    }
    return true;
  }

  render() {
    if(this.isAllGrouponsRefundedOrRedeemed()){
      return null;
    }
    else if (this.props.landingView) {
       return  (
           <div class="ssa-block">
             {this.constructSSAs()}
             </div>
       )
    }
    else{
      return (
        <div class="ssa">
          {this.constructSSAs()}
        </div>
      );
    }
  }
}
module.exports = VoucherLevelSSA
